/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Subscription_PendingInputs */

const nl_app_subscription_pending = /** @type {(inputs: App_Subscription_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In behandeling`)
};

/**

* @param {App_Subscription_PendingInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const app_subscription_pending = /** @type {((inputs?: App_Subscription_PendingInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Subscription_PendingInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_app_subscription_pending(inputs)
});
export { app_subscription_pending as "app.subscription.pending" }